import { useHistory } from "react-router-dom";
import {
  Container,
  ContainerMenu,
  ToolsButton,
  ImgButtonsTools,
} from "./style";

const SubHeader = ({ style, path1, path2, path3, path4 }) => {
  const history = useHistory();

  return (
    <Container>
      <ContainerMenu>
        <ToolsButton
            selected={style[0]}
            onClick={() => history.push(path1)}
        >
          <ImgButtonsTools
            src="./images/sausage_pcp.svg"
            alt="sausage_pcp"
          />
        </ToolsButton>
        <ToolsButton 
            selected={style[1]}
            onClick={() => history.push(path2)}
        >
          <ImgButtonsTools
            src="./images/chicken_pcp.svg"
            alt="chicken_pcp"
          />
        </ToolsButton>
        <ToolsButton
            selected={style[2]} 
            onClick={() => history.push(path3)}
        >
          <ImgButtonsTools
            
            src="./images/cut_chicken_pcp.svg"
            alt="cut_chicken_pcp"
          />
        </ToolsButton>
        <ToolsButton 
            selected={style[3]}
            onClick={() => history.push(path4)}
        >
          <ImgButtonsTools
            src="./images/fries_pcp.svg"
            alt="fries_pcp"
          />
        </ToolsButton>
      </ContainerMenu>
    </Container>
  );
};
export default SubHeader;
